import { localized } from "@msuite/ui/localization";
import { StatusIndicator } from "@msuite/ui/status-indicator";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { createdAtFormatter } from "@msuite/utils/date";
import type { TranslationKey } from "@msuite/utils/locales";
import { getAddressString, guardString } from "@msuite/utils/strings";
import type { Enums, Tables } from "@msuite/utils/types";
import { RowActions } from "./row-actions";
import { WorkspaceDefaultApprovers } from "./workspace-default-approvers";

const columnHelper = createColumnHelper<
	Tables<"workspaces"> & {
		_meta?: Tables<"workspaceMeta">;
	}
>();

export const columns = [
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("name", {
		header: localized("organization.workspace"),
		id: "name",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => localized(`theme.${row.color}`), {
		header: localized("theme.color"),
		id: "color",
		cell: (cell) => (
			<div className="flex flex-row items-center gap-2">
				<StatusIndicator color={cell.row.original.color as Enums<"color">} />
				<p>{localized(`theme.${cell.row.original.color}` as TranslationKey)}</p>
			</div>
		),
	}),
	columnHelper.accessor("_meta.companyName", {
		header: localized("organization.company"),
		id: "companyName",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor((row) => getAddressString(row._meta), {
		header: localized("address.address"),
		id: "address",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("_meta.email", {
		header: localized("personnel.fields.email"),
		id: "email",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("_meta.phone", {
		header: localized("personnel.fields.phone"),
		id: "phone",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("_meta.web", {
		header: localized("personnel.fields.web"),
		id: "web",
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.display({
		header: localized("incoming_invoices.default_approvers"),
		id: "defaultApprovers",
		cell: (cell) => <WorkspaceDefaultApprovers workspaceId={cell.row.original.id} />,
	}),
	createRowActions(RowActions),
];
